'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Content(homeTitle, homeDescription, nav, cta, hero, promises, solutions, audits, soc2, architecture, toolkit, method, faq, contact, footer) {
  this.gR = null;
  this.fb = null;
  this.gT = null;
  this.gP = null;
  this.fa = null;
  this.gU = null;
  this.gW = null;
  this.gN = null;
  this.gV = null;
  this.gM = null;
  this.gX = null;
  this.gS = null;
  this.gQ = null;
  this.gO = null;
  this.cO = null;
  this.gR = homeTitle;
  this.fb = homeDescription;
  this.gT = nav;
  this.gP = cta;
  this.fa = hero;
  this.gU = promises;
  this.gW = solutions;
  this.gN = audits;
  this.gV = soc2;
  this.gM = architecture;
  this.gX = toolkit;
  this.gS = method;
  this.gQ = faq;
  this.gO = contact;
  this.cO = footer;
}
export { $c_Lio_intela_sites_intelacloud_content_Content as $c_Lio_intela_sites_intelacloud_content_Content };
$p = $c_Lio_intela_sites_intelacloud_content_Content.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Content;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Content() {
}
export { $h_Lio_intela_sites_intelacloud_content_Content as $h_Lio_intela_sites_intelacloud_content_Content };
$h_Lio_intela_sites_intelacloud_content_Content.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, (-799606171), true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Content)) {
    if (((this.gR === x$0.gR) && (this.fb === x$0.fb))) {
      var x = this.gT;
      var x$2 = x$0.gT;
      var $x_12 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_12 = false;
    }
    if ($x_12) {
      var x$3 = this.gP;
      var x$4 = x$0.gP;
      var $x_11 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_11 = false;
    }
    if ($x_11) {
      var x$5 = this.fa;
      var x$6 = x$0.fa;
      var $x_10 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_10 = false;
    }
    if ($x_10) {
      var x$7 = this.gU;
      var x$8 = x$0.gU;
      var $x_9 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$9 = this.gW;
      var x$10 = x$0.gW;
      var $x_8 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$11 = this.gN;
      var x$12 = x$0.gN;
      var $x_7 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$13 = this.gV;
      var x$14 = x$0.gV;
      var $x_6 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$15 = this.gM;
      var x$16 = x$0.gM;
      var $x_5 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$17 = this.gX;
      var x$18 = x$0.gX;
      var $x_4 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$19 = this.gS;
      var x$20 = x$0.gS;
      var $x_3 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$21 = this.gQ;
      var x$22 = x$0.gQ;
      var $x_2 = ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$23 = this.gO;
      var x$24 = x$0.gO;
      var $x_1 = ((x$23 === null) ? (x$24 === null) : x$23.f(x$24));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$25 = this.cO;
      var x$26 = x$0.cO;
      return ((x$25 === null) ? (x$26 === null) : x$25.f(x$26));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 15;
});
$p.I = (function() {
  return "Content";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gR;
      break;
    }
    case 1: {
      return this.fb;
      break;
    }
    case 2: {
      return this.gT;
      break;
    }
    case 3: {
      return this.gP;
      break;
    }
    case 4: {
      return this.fa;
      break;
    }
    case 5: {
      return this.gU;
      break;
    }
    case 6: {
      return this.gW;
      break;
    }
    case 7: {
      return this.gN;
      break;
    }
    case 8: {
      return this.gV;
      break;
    }
    case 9: {
      return this.gM;
      break;
    }
    case 10: {
      return this.gX;
      break;
    }
    case 11: {
      return this.gS;
      break;
    }
    case 12: {
      return this.gQ;
      break;
    }
    case 13: {
      return this.gO;
      break;
    }
    case 14: {
      return this.cO;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Content(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bq)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Content as $isArrayOf_Lio_intela_sites_intelacloud_content_Content };
var $d_Lio_intela_sites_intelacloud_content_Content = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Content, "io.intela.sites.intelacloud.content.Content", ({
  bq: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Content as $d_Lio_intela_sites_intelacloud_content_Content };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Content.js.map
